import styled from 'styled-components';

const getShadow = (shadowColorOne, shadowColorTwo, spreadingValue) => {
  let shadow = `0 0 ${spreadingValue} 0 ${shadowColorOne},`;
  shadow += ` 0 ${spreadingValue} ${spreadingValue} 0 ${shadowColorTwo}`;
  return shadow;
};

export default {
  Elevation: styled.div`
    box-shadow: ${props => getShadow(props.shadowColorOne, props.shadowColorTwo, props.spreadingValue)};
    background-color: ${props => props.backgroundColor};
  `
};